<template>
  <div
    class="rt-lookup"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    @click="show"
  >
    <el-input
      :disabled="computedDisabled"
      :value="inputText"
      :placeholder="placeholder"
      readonly
    />
    <rt-icon
      v-if="!showClose"
      name="rt-base-lookup"
    />
    <rt-icon
      v-if="showClose"
      name="rt-base-close"
      @click="clear"
    />
    <rt-dialog
      v-model="visible"
      :append-to-body="true"
      :title="title"
      @confirm="confirm"
      @cancel="cancel"
    >
      <rt-lookup-view
        :fetch="fetchRecord"
        :display-fields="displayFields"
        :multiple="multiple"
        :title="title"
        @change="change"
      />
    </rt-dialog>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtDialog from '../dialog/rtDialog';
import RtLookupView from './rtLookupView.vue';
import mixin from './mixin.js';
export default {
  name: 'RtCrmLookup',
  components: {
    RtIcon,
    RtDialog,
    RtLookupView
  },
  mixins: [mixin],
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  methods: {
    confirm () {
      const obj = {};
      const { selected, alias } = this;
      let id = '';
      let name = '';

      if (this.multiple) {
        id = selected ? selected.map(item => item[alias.id]).join(',') : '';
        name = selected ? selected.map(item => item[alias.name]).join(',') : '';
      } else {
        id = selected ? selected[alias.id] : '';
        name = selected ? selected[alias.name] : '';
      }
      obj[alias.id] = id;
      obj[alias.name] = name;
      this.$emit('input', obj);
      this.$emit('confirm', obj);
      this.selected = null;
    },
    fetchRecord (params) {
      const { pageSize, pageIndex, queryValue } = params
      let _params = Object.assign({}, this.params, {
        pageSize,
        pageIndex,
        queryValue
      });
      return this.$lookup.getCrmLookupData(_params);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCrmLookup.vue?0f820b03